// 로그인 페이지 (글래스 카드 + 그레인 배경)
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '../components/Button'
import { useAuth } from '../lib/auth'
import { useToast } from '../components/Toast'
import { useT } from '../lib/i18n'

export function LoginPage() {
  const { login } = useAuth()
  const nav = useNavigate()
  const loc = useLocation() as { state?: { from?: string } }
  const toast = useToast()
  const { t } = useT()
  // 운영 빌드는 빈 폼으로 시작. dev에선 자동 채움 (VITE_DEV_LOGIN_EMAIL/PASSWORD 설정 시).
  const [email, setEmail] = useState(import.meta.env.DEV ? (import.meta.env.VITE_DEV_LOGIN_EMAIL ?? '') : '')
  const [password, setPassword] = useState(import.meta.env.DEV ? (import.meta.env.VITE_DEV_LOGIN_PASSWORD ?? '') : '')
  const [busy, setBusy] = useState(false)

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    try {
      await login(email, password)
      toast.push('success', t('login.success'))
      nav(loc.state?.from ?? '/dashboard', { replace: true })
    } catch (err: any) {
      toast.push('error', err?.message ?? t('login.failed'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <main id="main" className="container" style={{ display: 'grid', placeItems: 'center', minHeight: 'calc(100svh - var(--header-h))' }}>
      <section
        aria-labelledby="login-h"
        className="glass"
        style={{ width: 'min(440px, 100%)', padding: '2rem' }}
      >
        <h1 id="login-h" style={{ fontSize: 'var(--fs-xl)' }}>
          <FontAwesomeIcon icon="lock" aria-hidden="true" /> {t('login.title')}
        </h1>
        <p className="muted">{t('login.subtitle')}</p>
        <form onSubmit={onSubmit} noValidate>
          <div className="field">
            <label htmlFor="email">{t('login.email')}</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="password">{t('login.password')}</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button type="submit" variant="accent" disabled={busy} aria-busy={busy} style={{ width: '100%', justifyContent: 'center' }}>
            {busy ? <FontAwesomeIcon icon="circle-notch" spin /> : <FontAwesomeIcon icon="arrow-right" />}
            <span>{busy ? t('login.submitting') : t('login.submit')}</span>
          </Button>
        </form>
        {import.meta.env.VITE_DEMO_BUTTON === '1' && (
          <div style={{ marginTop: '1.25rem', paddingTop: '1.25rem', borderTop: '1px solid var(--color-line)' }}>
            <Button
              type="button"
              variant="ghost"
              disabled={busy}
              onClick={async () => {
                setBusy(true)
                try {
                  await login('demo@comnjeong.local', 'Demo!2026Try')
                  toast.push('success', t('login.demoSuccess'))
                  nav('/dashboard', { replace: true })
                } catch (err: any) {
                  toast.push('error', err?.message ?? t('login.failed'))
                } finally {
                  setBusy(false)
                }
              }}
              style={{ width: '100%', justifyContent: 'center' }}
            >
              <FontAwesomeIcon icon="play" aria-hidden="true" />
              <span>{t('login.demo')}</span>
            </Button>
            <p className="muted" style={{ fontSize: 'var(--fs-sm)', marginTop: '0.5rem', textAlign: 'center' }}>
              {t('login.demoHint')}
            </p>
          </div>
        )}
      </section>
    </main>
  )
}
